import { psAxios } from '@patsnap/common-ps-http';
import { loginSDK } from '@eureka/shared/login-sdk';
import { container } from '@/inversify.config';
import { PricingDialogService } from '@eureka/shared/pricing';

/**
 * 检查错误码并处理登录逻辑
 */
const handleCheckingError = (errorCode: number, message: string) => {
    // 游客版超限错误
    if (errorCode === 33110015) {
        loginSDK.open().then(() => {
            window.location.reload();
        });
        return Promise.reject(new Error(message));
    }
    // 免费版超限错误
    if (errorCode === 33100007) {
        const pricingDialogService = container.get<PricingDialogService>(PricingDialogService);
        pricingDialogService.open();
        return Promise.reject(new Error(message));
    }
    return null;
};

/**
 * 成功响应拦截器 - 检查错误码 33110015，如果匹配则弹出登录框
 */
export const checkingErrorInterceptorSuccessHandel = (response: any) => {
    const errorCode = response?.data?.data?.numeric_error_code;
    const message = response?.data?.data?.error_message;

    const result = handleCheckingError(errorCode, message);
    if (result) return result;

    return response;
};

/**
 * 错误响应拦截器 - 检查错误码 33110015，如果匹配则弹出登录框
 */
export const checkingErrorInterceptorErrorHandel = (e: any) => {
    const errorCode = e?.response?.data?.numeric_error_code;
    const message = e?.response?.data?.error_message;

    const result = handleCheckingError(errorCode, message);
    if (result) return result;

    return Promise.reject(e);
};

export function injectCheckingErrorInterceptor() {
    if (!psAxios.psInterceptors.checkingErrorInterceptor) {
        psAxios.psInterceptors.checkingErrorInterceptor = psAxios.interceptors.response.use(
            checkingErrorInterceptorSuccessHandel,
            checkingErrorInterceptorErrorHandel
        );
    }
}

export function ejectCheckingErrorInterceptor() {
    psAxios.interceptors.response.eject(
        psAxios.psInterceptors.checkingErrorInterceptor
    );
}
